import { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';
import GeneralLayout from '@layouts/general/general';
import React from 'react';
import { paths } from '@routes/paths';
import InvalidPage from '@pages/InvalidPage';

// ----------------------------------------------------------------------

const NotFoundPage = lazy(() => import('@pages/NotFoundPage'));

// ----------------------------------------------------------------------

export const mainRoutes = (
  <Route element={<GeneralLayout />}>
    <Route path="404" element={<NotFoundPage />} />
    <Route path={paths.invalid.index} element={<InvalidPage />} />
  </Route>
);
